import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useDelayed } from '../../../hooks/useDelayed';
import { useBlockContext, useRefreshBlockInDefaultView } from '../../../_lib/BlockFetcher';
import { ContentParagraph, ContentParagraphModifier } from '../../../_lib/components/ContentParagraph';
import { CheckBoxParam, Form, Row, SonForm, SubmitButton, Switch, useForm } from '../../../_lib/Form2';
import { BlockType } from '../../../types/api/ElementType';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';

type EditViewProps = { form: SonForm<CheckBoxParam<'active'>> };

function CommentsEdit({ form }: EditViewProps) {
  const { elementType } = useBlockContext();
  const { refresh } = useRefreshBlockInDefaultView();
  const delayedRefresh = useDelayed(refresh);
  const { t } = useSonTranslation(elementType === BlockType.comments ? 'CommentsBlock' : 'EditorFeedback');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: delayedRefresh,
  });

  const active = params.getByName('active');
  const id = useHtmlValidId();
  const formId = elementType + '-form' + id;
  return (
    <Form id={formId} {...formProps}>
      <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>
        {t('edit.explainingText')}
      </ContentParagraph>
      <Row>
        <Switch label={t('edit.label')} param={active} />
      </Row>
      <SubmitButton
        buttonLabel={t('edit.submit')}
        messageSuccess={t('phrases:changeSuccesfull')}
        messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
        messageFail={t('phrases:changesCouldNotBeSaved')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const CommentsEditView = asFetchableView(CommentsEdit);
export type CommentsEditView = ComponentProps<typeof CommentsEditView>;
